export default "__VITE_ASSET__r7oQbNt2__"